var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"normal-box"},[_c('img',{attrs:{"src":require("../assets/normal.png"),"alt":""}}),_vm._v("\n  暂无数据\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }